import React, { useEffect, useState } from 'react';
import { getImage, getSymbolCategoriesForProduct, getSymbolsForProduct } from '../../../server/server';
import Loading from '../../../common/Loading';
import { ReactComponent as BackButton } from '../../../assets/icons/backConfigurationIcon.svg';
import { useTranslation } from 'react-i18next';
type Type = {
	addSymbol: any;
	productId?: string;
};
function AddSymbols({ addSymbol, productId = '' }: Type) {
	const [symbols, setSymbols] = useState([]);
	const [selectedState, setSelectedState] = useState('list');
	const [selectedCategory, setSelectedCategory] = useState<any>({});
	const [categories, setCategories] = useState([]);
	const [loadingSymbols, setLoadingSymbols] = useState(true);

	useEffect(() => {
		getCategories();
	}, []);

	useEffect(() => {
		if (!!selectedCategory?.id) {
			setLoadingSymbols(true);
			getSymbols(selectedCategory.id);
		}
	}, [selectedCategory]);

	const getSymbols = async (categoryId?: string) => {
		const resp = await getSymbolsForProduct(productId, categoryId);
		if (resp.status === 200) {
			setSymbols(resp.data);
			setLoadingSymbols(false);
		}
	};

	const selectCategory = (category: string) => {
		setSelectedCategory(category);
		setSelectedState('category');
	};

	const getCategories = async () => {
		const resp = await getSymbolCategoriesForProduct(productId);
		if (resp.status === 200) {
			setCategories(resp.data);
			setLoadingSymbols(false);
		}
	};

	const goBack = () => {
		setSelectedState('list');
		setSelectedCategory({});
		setSymbols([]);
	};
	return (
		<div className="border-t border-t-[#D4C4F6] mt-[30px] pt-[25px]">
			{selectedState == 'list' && (
				<div className="flex flex-row flex-wrap gap-y-[25px] gap-x-[16px]  pb-[50px] -mx-[20px]  px-[30px]">
					{categories.map((category: any) => (
						<SymbolCategoryButton symbol={getImage(category?.image?.id)} name={category.name} onSelect={selectCategory} key={category?.name} category={category} />
					))}
				</div>
			)}
			{selectedState == 'category' && (
				<div className="flex flex-col flex-wrap gap-y-[25px] gap-x-[16px] pb-[50px] -mt-[182px] bg-white w-full min-h-[530px]">
					<div className="flex flex-row gap-[20px] items-center p-[11px] border-b-[#D4C4F6] border-b">
						<button className="h-[21.67px] w-[21.67px] rounded-full bg-[#D1D5DB] flex items-center justify-center" onClick={goBack}>
							<BackButton />
						</button>
						<label htmlFor="style your text" className="uppercase text-[14px] leading-[25px] truncate max-w-[430px] font-bold">
							<span className="font-normal">{selectedCategory.name}</span>
						</label>
					</div>
					<div className="flex flex-row flex-wrap gap-y-[25px] gap-x-[16px]  pb-[50px] -mx-[20px]  px-[30px]">
						{symbols.map((symbol: any) => (
							<SymbolButton key={symbol.id} symbol={getImage(symbol.imageId)} addSymbol={addSymbol} imageId={symbol.imageId} />
						))}
					</div>
				</div>
			)}
		</div>
	);
}
const SymbolButton = ({ symbol = '', addSymbol, imageId = '' }: { symbol: string; imageId: string; addSymbol: ({ symbol, imageId }: { symbol: string; imageId: string }) => void }) => {
	const [loaded, setLoaded] = useState(false);
	return (
		<button className=" w-[69px] h-[69px] transition-all duration-[230ms] hover:scale-[1.2] relative" onClick={() => addSymbol({ symbol, imageId })}>
			<img src={symbol} alt="Symbol" width={69} height={69} className="object-fill" onLoad={() => setLoaded(true)} />
			{!loaded && (
				<div className="absolute top-0 bottom-0 left-0 right-0 flex items-center justify-center">
					<Loading height={40} />
				</div>
			)}
		</button>
	);
};
const SymbolCategoryButton = ({ symbol = '', onSelect, name, category }: { symbol: string; name: string; onSelect: (category: any) => void; category: any }) => {
	const { t } = useTranslation();
	const [loaded, setLoaded] = useState(false);
	return (
		<button className=" w-[100px] min-h-[100px] transition-all duration-[230ms] hover:scale-[1.1] relative flex justify-center items-center flex-col gap-[10px]" onClick={() => onSelect(category)}>
			<div className="max-h-[40px] min-h-[40px] w-[100%] bg-[#F1F1FE] rounded-tl-[10px] rounded-tr-[10px] font-bold justify-center flex items-center text-[14px]">{t(name)}</div>
			<img src={symbol} alt="Symbol" width={69} height={69} className="object-fill" onLoad={() => setLoaded(true)} />
			{!loaded && (
				<div className="absolute top-0 bottom-0 left-0 right-0 flex items-center justify-center">
					<Loading height={40} />
				</div>
			)}
		</button>
	);
};

export default AddSymbols;
